function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2814",
  "data-name": "Rectangle 2814",
  width: 427,
  height: 239,
  rx: 8,
  fill: "#f5f6f8"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4209",
  "data-name": "Group 4209",
  transform: "translate(149.748 64.282)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4169",
  "data-name": "Group 4169",
  transform: "translate(0 0)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1588",
  "data-name": "Path 1588",
  d: "M116.365,2H12.929A12.944,12.944,0,0,0,0,14.93V86.042a12.944,12.944,0,0,0,12.929,12.93H116.365a12.944,12.944,0,0,0,12.93-12.93V14.93A12.944,12.944,0,0,0,116.365,2Z",
  transform: "translate(0 -2)",
  fill: "#afb5b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1589",
  "data-name": "Path 1589",
  d: "M7.465,3H110.9a6.471,6.471,0,0,1,6.465,6.465V66.32L77.63,26.687a3.235,3.235,0,0,0-4.583.016L44.778,55.255l-9.169-9.17a3.231,3.231,0,0,0-4.571,0L1,76.12V9.465A6.471,6.471,0,0,1,7.465,3Z",
  transform: "translate(5.465 3.465)",
  fill: "#c2c7cb"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_374",
  "data-name": "Ellipse 374",
  cx: 12.929,
  cy: 12.93,
  rx: 12.929,
  ry: 12.93,
  transform: "translate(38.788 13.046)",
  fill: "#afb5b9"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_375",
  "data-name": "Ellipse 375",
  cx: 6.465,
  cy: 6.465,
  rx: 6.465,
  ry: 6.465,
  transform: "translate(45.253 19.511)",
  fill: "#f5f6f8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1590",
  "data-name": "Path 1590",
  d: "M109.9,61.212H6.469a6.357,6.357,0,0,1-5.287-2.959L32.328,27.111,49.317,44.1a3.232,3.232,0,0,0,4.571-4.571L48.352,34,74.361,7.727l42.008,41.9v5.121A6.471,6.471,0,0,1,109.9,61.212Z",
  transform: "translate(6.461 29.294)",
  fill: "#f5f6f8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1592",
  "data-name": "Path 1592",
  d: "M1.364,15.748c.013.011.027.019.039.03C1.392,15.767,1.377,15.759,1.364,15.748Z",
  transform: "translate(7.456 73.131)",
  fill: "#fff",
  opacity: 0.2
})), /*#__PURE__*/React.createElement("text", {
  id: "Page_Title",
  "data-name": "Page Title",
  transform: "translate(20.398 130.111)",
  fill: "#596375",
  fontSize: 18,
  fontFamily: "NunitoSans-Regular, Nunito Sans",
  letterSpacing: "0.02em",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Pilih Foto")));

var SvgImageUpload = function SvgImageUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 239,
    viewBox: "0 0 427 239",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-upload.9af907bc.svg";
export { ForwardRef as ReactComponent };